import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export
} from 'devextreme-react/data-grid';
import Request from "../../components/api/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import * as Utils from '../../utils/Utils';
import DropDownBox from 'devextreme-react/drop-down-box';
import TreeView from 'devextreme-react/tree-view';
import { Popup } from 'devextreme-react/popup';
import { showToast, parseDate, showDialog, hasRole } from "../../utils/Utils";
import { ToastType } from "../../constants/Constants";
import CariDonemBilgi from '../caridonem/CariDonemBilgi';
import './CariDonemRapor.scss';
import CariDonemLoginIslemleri from "../sgklogin/CariDonemLoginIslemleri";
import FileUploader from 'devextreme-react/file-uploader';
import * as AppActions from '../../actions/AppActions';
import CariDonemPersonelDetay from './CariDonemPersonelDetay';
import TesvikDetayIslemleri from '../tesvikdetay/TesvikDetayIslemleri';
import TesvikRaporIslemleri from '../tesvikrapor/TesvikRaporIslemleri';


const CariDonemRapor = (props) => {

    const dispatch = useDispatch();

    const username =localStorage.getItem('username') ;

    const url =  window.location.hostname;

    const [formYetki, setFormYetki] = useState(
        {
            cariDonemFirmaListeleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemFirmaListeleme"),
            cariDonemBilgiGoruntuleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemBilgiGoruntuleme"),
            cariDonemBilgiKaydetme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemBilgiKaydetme"),
            sgkOnayliDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkOnayliDonemIndir"),
            sgkCariDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkCariDonemIndir"),
            sgkOncekiDonemIndir: hasRole("cariDonem|cariDonemTesvikRapor|sgkOncekiDonemIndir"),
            sgkTesvikKaydet: hasRole("cariDonem|cariDonemTesvikRapor|sgkTesvikKaydet"),
            cariDonemExcelXmlImport: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemExcelXmlImport"),
            cariDonemXmlImportExport: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemXmlImportExport"),
            cariDonemExcelExport: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemExcelExport"),
            cariDonemExcelExportOzet: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemExcelExportOzet"),
            cariDonemAktarilanPersonellistesiGoruntuleme: hasRole("cariDonem|cariDonemTesvikRapor|cariDonemAktarilanPersonellistesiGoruntuleme"),
            firmaSablonIndir: !url.includes("ari-ik")
        });


    const listeBasligi = "Cari Dönem Çalışma";
    const [store, setStore] = useState(null);
    const [cariDonemData, setCariDonemData] = useState({ popupState: false, data: [] });
    const [treeBoxValue, setTreeBoxValue] = useState([]);
    const [treeDataSource, setTreeDataSource] = useState([]);
    const inputOpenFileRef = React.createRef();
    const [cariDonemDetayData, setCariDonemDetayData] = useState({ popupState: false, data: {} });

    const [cariDonemPersonelDetayData, setCariDonemPersonelDetayData] = useState({ popupState: false, data: {} });
    const [tesvikDetayIslemData, setTesvikDetayIslemData] = useState({ popupState: false, data: {} });
    const [tesvikRarporIsemleriData, setTesvikRarporIsemleriData] = useState({ popupState: false, data: {} });

    


    useEffect(() => {
        domainListYukle();
        setStore(getStore());
    }, [])

    const domainListYukle = () => {

        const request = new Request("/userDomain/getUserDomainList", "GET");

        request.run()
            .then(response => {
                if (response.data) {
                    setTreeDataSource(response.data.data);
                } else {
                    return []

                }
            });
    }

    let dataGrid = null;
    let treeView = null;

    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {


                let data = {
                    domainIdList: treeBoxValue
                }

                const request = new Request("/cariDonemTesvikRapor/getCariDonemDomainTesvikInfoList", "POST", data);

                return request.run()
                    .then(response => {
                        if (response.data) {

                            response.data.data.map(d => {
                                if (d.donemTesvikBilgi != null) {
                                    d.donemTesvikBilgi.cariDonemTesvikSorguZamani = parseDate(d.donemTesvikBilgi.cariDonemTesvikSorguZamani);
                                    d.donemTesvikBilgi.oncekiDonemTesvikSorguZamani = parseDate(d.donemTesvikBilgi.oncekiDonemTesvikSorguZamani);
                                    d.donemTesvikBilgi.tesvikOnayZamani = parseDate(d.donemTesvikBilgi.tesvikOnayZamani);
                                    d.donemTesvikBilgi.onayliTesvikListeGuncellemeZamani = parseDate(d.donemTesvikBilgi.onayliTesvikListeGuncellemeZamani);
                                    d.donemTesvikBilgi.dataAktarimZamani = parseDate(d.donemTesvikBilgi.dataAktarimZamani);
                                }
                                if (d.cariDonem != null) {
                                    d.cariDonem.tarih = parseDate(d.cariDonem.tarih);
                                }
                                if (d.oncekiDonem != null) {
                                    d.oncekiDonem.tarih = parseDate(d.oncekiDonem.tarih);
                                }
                            });
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    const yenile = () => {
        let domains = treeBoxValue;
        if (domains.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }
        setStore(getStore());
    }

    const syncTreeViewSelection = (e) => {
        let tree = (e.component.selectItem && e.component) || (treeView && treeView.instance);

        if (tree) {
            if (e.value === null) {
                tree.unselectAll();
            } else {
                let values = e.value || treeBoxValue;
                values && values.forEach(function (value) {
                    tree.selectItem(value);
                });
            }
        }

        if (e.value !== undefined) {
            if (e.value == null) {
                setTreeBoxValue([]);
            } else {
                setTreeBoxValue(e.value);
            }
        }
    }

    const treeView_itemSelectionChanged = (e) => {
        setTreeBoxValue(e.component.getSelectedNodeKeys());
    }

    const treeViewRender = () => {
        return (
            <TreeView dataSource={treeDataSource}
                ref={(ref) => treeView = ref}
                dataStructure="plain"
                keyExpr="id"
                key="id"
                parentIdExpr="parent.id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                selectNodesRecursive={true}
                displayExpr="name"
                selectByClick={true}
                onContentReady={syncTreeViewSelection}
                onItemSelectionChanged={treeView_itemSelectionChanged}
                searchMode={'contains'}
                searchEnabled={true}
            />
        );
    }

    const cariDonemPopupShow = (data) => {
        if (data && data.domain) {
            setCariDonemData({
                popupState: true,
                data: { domainId: data.domain.id }
            });
        } else {
            Utils.showToast("Firma Seçiniz", ToastType.ERROR, 500);
        }
    }
    function hideCariDonemDataPopup() {
        setCariDonemData({ popupState: false, data: {} })
        yenile();
    }
    const cariDonemPersonelDetayPopupShow = (data) => {
        if (data && data.domain) {
            setCariDonemPersonelDetayData({
                popupState: true,
                data: { domainId: data.domain.id }
            });
        } else {
            Utils.showToast("Firma Seçiniz", ToastType.ERROR, 500);
        }
    }
    function hideCariDonemPersonelDetayPopup() {
        setCariDonemPersonelDetayData({ popupState: false, data: {} })
        yenile();
    }

    function hideCariDonemDetayIslemleriPopup() {
        setCariDonemDetayData({ popupState: false, data: {} })
        yenile();
    }
    function showCariDonemDetayIslemleriPopup(data) {
        setCariDonemDetayData({
            popupState: true,
            data: data
        });
    }

    function cariDonemTesvikSorguZamaniStyle(rowData) {
        let data = rowData.row.data.donemTesvikBilgi;

        if (data != null) {
            if (data.cariDonemTesvikSorguZamani != null) {
                if (data.oncekiDonemTesvikSorguZamani == null || data.oncekiDonemTesvikSorguZamani > data.cariDonemTesvikSorguZamani) {
                    return <div style={{ backgroundColor: '#F6BB42', margin: 0 }}> <b>{rowData.text}</b></div>
                }
            }
        }
        return rowData.text;
    }

    function tesvikOnayZamaniStyle(rowData) {

        let data = rowData.row.data.donemTesvikBilgi;
        if (data != null) {
            if (data.tesvikOnayZamani != null) {
                if (data.cariDonemTesvikSorguZamani == null || data.cariDonemTesvikSorguZamani > data.tesvikOnayZamani) {
                    return <div style={{ backgroundColor: '#F6BB42', margin: 0 }}> <b>{rowData.text}</b></div>
                }
            }
        }
        return rowData.text;
    }

    function onayliTesvikListeGuncellemeZamaniStyle(rowData) {

        let data = rowData.row.data.donemTesvikBilgi;
        if (data != null) {
            if (data.onayliTesvikListeGuncellemeZamani != null) {
                if (data.tesvikOnayZamani == null || data.tesvikOnayZamani > data.onayliTesvikListeGuncellemeZamani) {
                    return <div style={{ backgroundColor: '#F6BB42', margin: 0 }}> <b>{rowData.text}</b></div>
                }
            }
        }
        return rowData.text;
    }

    function dataAktarimZamaniStyle(rowData) {

        let data = rowData.row.data.donemTesvikBilgi;
        if (data != null) {
            if (data.dataAktarimZamani != null) {
                if (data.onayliTesvikListeGuncellemeZamani == null || data.onayliTesvikListeGuncellemeZamani > data.dataAktarimZamani) {
                    return <div style={{ backgroundColor: '#F6BB42', margin: 0 }}> <b>{rowData.text}</b></div>
                }
            }
        }
        return rowData.text;
    }

    function dosyaYukle(file) {

        const formData = new FormData();
        formData.append('file', file);

        const request = new Request("/cariDonemTesvikRapor/dosyaYukle", "POST", formData, "multipart/form-data");
        dispatch(AppActions.setLoading(true, "Dosya Yükleniyor.."));
        request.run().then((response) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data && response.data.data.success === true) {
                let veriYuklenenFirmalar = response.data.data.veriYuklenenDomainList.join("\n");
                showDialog({ title: 'Belge Yükleme Başarılı', message: veriYuklenenFirmalar, buttons: "OK" })
                    .then((dialogResult) => {
                        yenile();
                    });
            } else {
                let mesaj ="";
                if(response && response.response && response.response.data && response.response.data.message){
                    mesaj =response.response.data.message;
                }
                showDialog({ title: 'Belge Yükleme Yapılamadı', message: "Dosyayı kontrol ediniz <br>" +mesaj , buttons: "OK" });
            }
        });

    }

    function uploadFile(e) {
 
        if (inputOpenFileRef) {
            //inputOpenFileRef.current.instance.reset("valueChanged");
            inputOpenFileRef.current.instance._$fileInput.val("")
            inputOpenFileRef.current.instance._isCustomClickEvent = true
            inputOpenFileRef.current.instance._$fileInput[0].click();
            inputOpenFileRef.current.instance._eventsStrategy._events.valueChanged = null;
            inputOpenFileRef.current.instance.on("valueChanged",
                (e1) => {
                    let fileExtensionXml = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    let fileExtensionXlsx = e1.value[0].name.substring(e1.value[0].name.length - 5);
                    let fileExtensionTxt = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    if (fileExtensionXml.toUpperCase() === ".XML" || fileExtensionXml.toUpperCase() === ".XLS") {
                        dosyaYukle(e1.value[0]);
                    } else if (fileExtensionXlsx.toUpperCase() === ".XLSX") {
                        dosyaYukle(e1.value[0]);
                    }  else if (fileExtensionTxt.toUpperCase() === ".TXT") {
                        dosyaYukle(e1.value[0]);
                    }else {
                        showToast('Hatalı dosya tipi', ToastType.ERROR, 500);
                    }
                })
        }

    }
    function downloadTumPersonelExcelFile() {
        downloadFile(true);
    }
    function downloadExcelFile() {
        downloadFile(false);
    }
    function downloadFile(tumPersonel) {
        let tempGrid = dataGrid;

        let data = {
            domainIdList: [],
            tumPersonel: tumPersonel,
            baseUrl :window.location.hostname
        }

        tempGrid.instance.getSelectedRowsData().map(sd => {
            data.domainIdList.push(sd.domain.id);
        });

        if (data.domainIdList.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }

        const request = new Request("/cariDonemTesvikRapor/getCariDonemExcelFile", "POST", data);
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response, e, f) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.data.success) {

                    if (response.data.data.fileName.length > 50) {
                        response.data.data.fileName = response.data.data.fileName.substring(0, 50);
                    }

                    let base64File = response.data.data.file;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download = response.data.data.fileName + '.xlsx';
                    a.href = href;
                    a.click();
                    a.href = '';

                    showToast('Belge başarılı bir şekilde yüklendi', ToastType.INFO, 500);
                    yenile();
                } else {

                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);
                    yenile();
                }

            }
        });

    }

    function downloadExcelFileOzet() {
        let tempGrid = dataGrid;
        let data = {
            domainIdList: [],
            tumPersonel: true,
            baseUrl: window.location.hostname
        };
        tempGrid.instance.getSelectedRowsData().map(sd => {
            data.domainIdList.push(sd.domain.id);
        });
        if (data.domainIdList.length == 0) {
            showToast('Firma Seçiniz', ToastType.ERROR, 500);
            return;
        }
        const request = new Request("/cariDonemTesvikRapor/getCariDonemExcelFile-ozet", "POST", data);
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.data.success) {
                    if (response.data.data.fileName.length > 50) {
                        response.data.data.fileName = response.data.data.fileName.substring(0, 50);
                    }
                    let base64File = response.data.data.file;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download = response.data.data.fileName + '.xlsx';
                    a.href = href;
                    a.click();
                    a.href = '';
                    showToast('Belge başarılı bir şekilde yüklendi', ToastType.INFO, 500);
                    yenile();
                } else {
                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);
                    yenile();
                }
            }
        });
    }

    
    function xmlFileUploadAndExport(e) {
 
        if (inputOpenFileRef) {
            //inputOpenFileRef.current.instance.reset("valueChanged");
            inputOpenFileRef.current.instance._$fileInput.val("")
            inputOpenFileRef.current.instance._isCustomClickEvent = true
            inputOpenFileRef.current.instance._$fileInput[0].click();
            inputOpenFileRef.current.instance._eventsStrategy._events.valueChanged = null;
            inputOpenFileRef.current.instance.on("valueChanged",
                (e1) => {
                    let fileExtensionXml = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    let fileExtensionXlsx = e1.value[0].name.substring(e1.value[0].name.length - 5);
                    let fileExtensionTxt = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    if (fileExtensionXml.toUpperCase() === ".XML") {
                        xmlFileImportAndExport(e1.value[0]);
                    } else {
                        showToast('Hatalı dosya tipi', ToastType.ERROR, 500);
                    }
                })
        }

    }
    function xmlFileImportAndExport(file) {
        const formData = new FormData();
        formData.append('file', file);

        const request = new Request("/cariDonemTesvikRapor/xmlFileExport", "POST", formData, "multipart/form-data");
        dispatch(AppActions.setLoading(true, "Dosya Yükleniyor.."));
        request.run().then((response) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.data.success) {

                    if (response.data.data.fileName.length > 50) {
                        response.data.data.fileName = response.data.data.fileName.substring(0, 50);
                    }

                    let base64File = response.data.data.file;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download = response.data.data.fileName + '.xml';
                    a.href = href;
                    a.click();
                    a.href = '';

                    showToast('Belge başarılı bir şekilde yüklendi', ToastType.INFO, 500);
                    yenile();
                } else {

                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);
                    yenile();
                }

            }
        });

    }

    function onToolbarPreparingDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'download',
                onClick: () => {
                    downloadSablon(null);
                }
            }
        });
    }
    function downloadSablon() {
        const request = new Request("/cariDonemTesvikRapor/getExcelSablon", "GET");
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response, e, f) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.success) {

                    let base64File = response.data.data;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download = 'Cari Dönem Import Format.xlsx';
                    a.href = href;
                    a.click();
                    a.href = '';
                } else {
                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);;
                }

            }
        });
    }
    function firmaSablonIndir(data) {
        let id =data.id;
        let dosyaAdi =data.domain.name + '_' + data.cariDonem.donem;
        const request = new Request("/cariDonemTesvikRapor/getFirmaSablon/" + id, "GET");
        dispatch(AppActions.setLoading(true, "Dosya İndiriliyor.."));
        request.run().then((response, e, f) => {
            dispatch(AppActions.setLoading(false, ""));
            if (response && response.data && response.data.data) {
                if (response.data.success) {

                    let base64File = response.data.data;
                    const href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64File;
                    var a = window.document.createElement('a');
                    a.download =dosyaAdi +'.xlsx';
                    a.href = href;
                    a.click();
                    a.href = '';
                } else {
                    showToast(response.data.data.mesaj, ToastType.WARNING, 500);;
                }

            }
        });
    }
    function hideTesvikDetayIslemPopup() {
        setTesvikDetayIslemData({ popupState: false, data: {} })
    }
    function showTesvikDetayIslemPopup(data) {
        setTesvikDetayIslemData({
            popupState: true,
            data: {
                domainId: data.domain.id,
                donemId: data.cariDonem.id,
            }
        });
    }

    function hideTesvikRaporIslemleriPopup() {
        setTesvikRarporIsemleriData({ popupState: false, data: {} })
    }
    function showTesvikRaporIslemleriPopup(data) {
        setTesvikRarporIsemleriData({
            popupState: true,
            data: {
                domainId: data.domain.id,
                donemId: data.cariDonem.id,
            }
        });
    }
    const linkRef = React.createRef();
    return (
        <div >
            <a ref={linkRef} />
            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>
                    <DropDownBox
                        value={treeBoxValue}
                        valueExpr="id"
                        displayExpr="name"
                        placeholder="Firma Seçiniz..."
                        showClearButton={true}
                        dataSource={treeDataSource}
                        onValueChanged={syncTreeViewSelection}
                        contentRender={treeViewRender}
                        width="500"
                    />
                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }} onClick={yenile}></Button>

                    <Button
                        icon="upload"
                        width={200}
                        text="Xml-Excel Dosya Yükle"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={uploadFile}
                        visible= { formYetki.cariDonemExcelXmlImport}
                    />
                    <Button
                        icon="download"
                        width={200}
                        text="Excel İndir"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={downloadExcelFile}
                        visible= { formYetki.cariDonemExcelExport}
                    />
                    <Button
                        icon="download"
                        width={200}
                        text="Excel İndir(TümListe)"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={downloadTumPersonelExcelFile}
                        visible= { formYetki.cariDonemExcelExport}
                    />
                    <Button
                        icon="download"
                        width={240}
                        text="Excel İndir(Tüm Liste Özet)"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={downloadExcelFileOzet}
                        visible={formYetki.cariDonemExcelExportOzet}
                    />

                    <Button
                        icon="upload"
                        width={200}
                        text="Xml Değiştir"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={xmlFileUploadAndExport}
                        visible= { formYetki.cariDonemXmlImportExport}
                    />
                    <FileUploader
                        ref={inputOpenFileRef}
                        selectButtonText=""
                        labelText=""
                        visible={false}
                        accept={'.xml,.xlsx,.xls,.txt'}
                        allowedFileExtensions={['.xml', '.xlsx', '.txt']}
                        uploadMode="useForm" />
                </div>
            </div>
            <DataGrid
                className="cariDonemRaporGridlist"
                ref={ref => dataGrid = ref}
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                //selection={{ mode: 'single', deferred: true }} 
                onToolbarPreparing={onToolbarPreparingDetay}
            >
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Selection mode="multiple" selectAllMode="page" showCheckBoxesMode="onClick" deferred={false} />

                <Column type="buttons" caption={'İşlem'}
                    buttons={[
                        { 
                            hint: 'Hesaplama İşlemleri', 
                            icon: 'download', 
                            visible: () => { return formYetki.sgkOnayliDonemIndir || formYetki.sgkCariDonemIndir || formYetki.sgkOncekiDonemIndir  || formYetki.sgkTesvikKaydet },
		                    onClick: (e) => { showCariDonemDetayIslemleriPopup(e.row.data); } 
                        },
                        { 
                            hint: 'Cari Donem Bilgi Güncelle', 
                            icon: 'info', 
                            visible: () => { return formYetki.cariDonemBilgiGoruntuleme },
                            onClick: (e) => { cariDonemPopupShow(e.row.data); } 
                        },
                        { 
                            hint: 'Cari Donem Personel Detay', 
                            icon: 'alignjustify', 
                            visible: () => { return formYetki.cariDonemAktarilanPersonellistesiGoruntuleme },
                            onClick: (e) => { cariDonemPersonelDetayPopupShow(e.row.data); } 
                        },
                        { 
                            hint: 'Firma Şablon indir', 
                            icon: 'download', 
                            visible: () => { return formYetki.firmaSablonIndir },
		                    onClick: (e) => { firmaSablonIndir(e.row.data); } 
                        },
                    ]}
                />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />
                <Column dataField={'domain.id'} width={90} caption={'Firma-Id'} dataType="number" visible={false} />

                <Column dataField={'domain.sicilNo'} width={200} caption={'SicilNo'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'domain.name'} width={250} caption={'Firma'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={"cariDonem.donem"} width={90} caption={'Cari-Dönem'} dataType="string" visible={true} />


                <Column dataField={"oncekiDonem.donem"} width={90} caption={'Önceki-Dönem'} dataType="string" visible={false} />

                <Column dataField={"donemTesvikBilgi.oncekiDonemTesvikSorguZamani"} width={130} caption={'Önceki Dönem Teşvik Sorgu Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true} />
                <Column dataField={"donemTesvikBilgi.cariDonemTesvikSorguZamani"} width={130} caption={'Teşvik Sorgu Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true}
                    cellRender={cariDonemTesvikSorguZamaniStyle}
                />
                <Column type="buttons" caption={'Detay'} width={30}
                    buttons={[
                        {
                            hint: 'Teşvik Detay Listesi',
                            icon: 'search',
                            visible: () => { return formYetki.cariDonemAktarilanPersonellistesiGoruntuleme },
                            onClick: (e) => { showTesvikDetayIslemPopup(e.row.data); }
                        },
                    ]}
                />
                <Column dataField={"donemTesvikBilgi.tesvikOnayZamani"} width={130} caption={'Teşvik Onay Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true}
                    cellRender={tesvikOnayZamaniStyle}
                />
                 <Column type="buttons" caption={'Detay'} width={30}
                    buttons={[
                        {
                            hint: 'Teşvik Listesi',
                            icon: 'search',
                            visible: () => { return formYetki.cariDonemAktarilanPersonellistesiGoruntuleme },
                            onClick: (e) => { showTesvikRaporIslemleriPopup(e.row.data); }
                        },
                    ]}
                />
                <Column dataField={"donemTesvikBilgi.onayliTesvikListeGuncellemeZamani"} width={130} caption={'Onaylı Teşvik Güncelleme Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true}
                    cellRender={onayliTesvikListeGuncellemeZamaniStyle}
                />
                <Column dataField={"donemTesvikBilgi.dataAktarimZamani"} width={130} caption={'Data Aktarım Zamanı'} dataType="date" format="yyyy-MM-dd HH:mm" visible={true}
                    cellRender={dataAktarimZamaniStyle}
                />

                <Column dataField={'donemTesvikBilgi.calisanSayi6111'} width={90} caption={'Ç.Sayı - 6111'} dataType="number" visible={true} />
                <Column dataField={'donemTesvikBilgi.calisanSayi7103'} width={90} caption={'Ç.Sayı - 7103'} dataType="number" visible={true} />

                



            </DataGrid>

            <Popup
                visible={cariDonemData.popupState}
                onHiding={hideCariDonemDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Cari Dönem Bilgi"
                width={450}
                height={700}
            >
                <div>
                    {cariDonemData.popupState ? <CariDonemBilgi data={cariDonemData.data} hide={hideCariDonemDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideCariDonemDataPopup}
                    />
                </div>
            </Popup>

            <Popup
                visible={cariDonemDetayData.popupState}
                onHiding={hideCariDonemDetayIslemleriPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Sgk Dönem işlemleri"
                width={300}
                height={340}
            >
                <div>
                    {cariDonemDetayData.popupState ? <CariDonemLoginIslemleri data={cariDonemDetayData.data} hide={hideCariDonemDetayIslemleriPopup} /> : null}
                </div>
            </Popup>

            <Popup
                visible={cariDonemPersonelDetayData.popupState}
                onHiding={hideCariDonemPersonelDetayPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={true}
                title="Cari Dönem Personel Detay"
                width={900}
                height={600}
            >
                <div>
                    {cariDonemPersonelDetayData.popupState ? <CariDonemPersonelDetay data={cariDonemPersonelDetayData.data} hide={hideCariDonemPersonelDetayPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideCariDonemPersonelDetayPopup}
                    />
                </div>
            </Popup>

            <Popup
                visible={tesvikDetayIslemData.popupState}
                onHiding={hideTesvikDetayIslemPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={false}
                //title="Teşvik Detay Listesi"
                width={1200}
                height={600}
            >
                <div>
                    {tesvikDetayIslemData.popupState ? <TesvikDetayIslemleri data={tesvikDetayIslemData.data} gridClassName="tesvikDetayPopupGrid" /> : null}
                    <Button
                        width={1200}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikDetayIslemPopup}
                    />
                </div>
            </Popup>

            <Popup
                visible={tesvikRarporIsemleriData.popupState}
                onHiding={hideTesvikRaporIslemleriPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                showTitle={false}
                //title="Teşvik Detay Listesi"
                width={1200}
                height={600}
            >
                <div>
                    {tesvikRarporIsemleriData.popupState ? <TesvikRaporIslemleri data={tesvikRarporIsemleriData.data} gridClassName="cariRaporTesvikRaporPopupGrid" /> : null}
                    <Button
                        width={1200}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideTesvikRaporIslemleriPopup}
                    />
                </div>
            </Popup>
        </div>
    )
}

export default CariDonemRapor;
